<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="row align-items-center justify-content-center" id="main_block">
            <section class="col-md-6 col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <h3>{{"CREATE_BARGAINING" | translate}}</h3>
                                <p class="font-small-4">{{"START_BARGAINING_INSTRUCTION" | translate}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-md-6" *ngIf="requestsList">
                                <label for="title">{{'MENU.CUSTOMERS_REQUESTS' | translate}}</label>
                                <ng-select id="title" [items]="requestsList" bindLabel="title" bindValue="id" [closeOnSelect]="true"
                                           [clearable]="false" [(ngModel)]="requestID" (change)="changeRequestCandidate()"></ng-select>
                            </div>
                            <div class="form-group col-12 col-md-6" *ngIf="requestsList">
                                <label for="candidate">{{'TITLES.USERS_TYPES.candidate' | translate}}</label>
                                <ng-select id="candidate" [items]="candidateList" bindLabel="user.complete_name" bindValue="user_hash" [closeOnSelect]="true"
                                           [clearable]="false" [(ngModel)]="candidateHash" *ngIf="candidateList && candidateList.length > 0"></ng-select>
                                <p *ngIf="candidateList && candidateList.length < 1">{{"ALERT.NOT_FOUND_CANDIDATE" | translate}}</p>
                            </div>
                            <div class="col-12 text-center mt-1" *ngIf="requestsList">
                              <button class="btn btn-primary" [routerLink]="'/dashboard/create-bargaining/' + this.candidateHash + '/' + this.requestID" [disabled]="!candidateHash ||candidateHash.length < 1">{{"START_BARGAINING" | translate}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>
